import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedRoutingModule } from './shared-routing.module';
import { SingleSelectComponent } from './components/single-select/single-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NotEmptyPipe } from './pipe/not-empty.pipe';
import { ToasterComponent } from './components/toaster/toaster.component';
import { DateTimePickerModule } from './components/date-time-picker/date-time-picker.module';
import { NavigationComponent } from './components/navigation/navigation.component';
import { FilterByPipe } from './pipe/filter-by.pipe';
import { SelectDropdownComponent } from './components/select-dropdown/select-dropdown.component';
import { LimitToPipe } from './pipe/limit-to.pipe';
import { SortByPipe } from './pipe/sort-by.pipe';
import { Datepicker_v2Component } from './components/datepicker_v2/datepicker_v2.component';
import { MessagePopUpComponent } from './components/message-pop-up/message-pop-up.component';
import { RadLabCommonListComponent } from './components/rad-lab-common-list/rad-lab-common-list.component';
import { PreventFirstSpaceDirective } from './directives/prevent-first-space.directive';
import { TruncatePipe } from './pipe/truncate.pipe';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AllSpacePreventDirective } from './directives/all-space-prevent/all-space-prevent.directive';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { CommonDetailsViewComponent } from './components/prescription-authorization-common/common-details-view/common-details-view.component';
import { CommonListComponent } from './components/common-list/common-list.component';
import { NumberOnlyDirective } from './directives/number-only/numberOnly.directive';
import { DateFormatPipe } from './pipe/dateFormat.pipe';
import { ForbiddenPageComponent } from './components/forbidden-page/forbidden-page.component';
// import { MonacoEditorModule } from 'ngx-monaco-editor-v2';


@NgModule({
  declarations: [
    SingleSelectComponent,
    LoaderComponent,
    ToasterComponent,
    NavigationComponent,
    NotEmptyPipe,
    FilterByPipe,
    SelectDropdownComponent,
    LimitToPipe,
    SortByPipe,
    Datepicker_v2Component,
    MessagePopUpComponent,
    RadLabCommonListComponent,
    PreventFirstSpaceDirective,
    TruncatePipe,
    TooltipDirective,
    AllSpacePreventDirective,
    CommonDetailsViewComponent,
    CommonListComponent,
    NumberOnlyDirective,
    DateFormatPipe,
    ForbiddenPageComponent
    
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DateTimePickerModule,
    DragDropModule,
    // MonacoEditorModule.forRoot(),
    NuMonacoEditorModule.forRoot(),
  ],
  exports:[
    SingleSelectComponent,
    DateTimePickerComponent,
    NavigationComponent,
    LoaderComponent,
    NotEmptyPipe,
    ToasterComponent,
    SelectDropdownComponent,
    Datepicker_v2Component,
    MessagePopUpComponent,
    RadLabCommonListComponent,
    PreventFirstSpaceDirective,
    TruncatePipe,
    TooltipDirective,
    DragDropModule,
    AllSpacePreventDirective,
    // MonacoEditorModule,
    NuMonacoEditorModule,
    CommonDetailsViewComponent,
    CommonListComponent,
    NumberOnlyDirective,
    DateFormatPipe,
    ForbiddenPageComponent

  ]
})
export class SharedModule { }
